import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Annonceur } from '../../models/annonceur.pwd';

@Injectable({
    providedIn: 'root'
})
export class AnnonceurService {

    public annonceurBhs: BehaviorSubject<Annonceur> = new BehaviorSubject(new Annonceur());

    constructor() { }

}
